import { reportingApi } from './reportingApiBase';
import { PMReportSummaryView, PMCenterBreakdownView, PMCategoryBreakdownView, PMReportFilters } from './types';

export const pmReportQueriesApi = reportingApi.injectEndpoints({
  endpoints: (builder) => ({
    getPMSummary: builder.query<PMReportSummaryView, PMReportFilters>({
      query: (filters) => ({
        url: 'tickets/pm/summary',
        params: {
          centerId: filters.centerId,
          category: filters.category,
          fromDate: filters.fromDate,
          toDate: filters.toDate,
        },
      }),
      providesTags: ['PMReport'],
    }),

    getPMByCenter: builder.query<PMCenterBreakdownView[], PMReportFilters>({
      query: (filters) => ({
        url: 'tickets/pm/by-center',
        params: {
          category: filters.category,
          fromDate: filters.fromDate,
          toDate: filters.toDate,
        },
      }),
      providesTags: ['PMReport'],
    }),

    getPMByCategory: builder.query<PMCategoryBreakdownView[], PMReportFilters>({
      query: (filters) => ({
        url: 'tickets/pm/by-category',
        params: {
          centerId: filters.centerId,
          fromDate: filters.fromDate,
          toDate: filters.toDate,
        },
      }),
      providesTags: ['PMReport'],
    }),
  }),
});

export const {
  useGetPMSummaryQuery,
  useGetPMByCenterQuery,
  useGetPMByCategoryQuery,
} = pmReportQueriesApi;
